export enum TPaymentMethodId {
  SAVED_CARDS = 'SAVED_CARDS',
  CLUB = 'CLUB',
  WEBPAY = 'WEBPAY',
  GIFT_CARD = 'GIFT_CARD',
  EPAY_TCOM = 'EPAY_TCOM',
  EPAY_CENCOSUD_TCOM = 'EPAY_CENCOSUD_TCOM',
  TRANSBANK = 'TRANSBANK',
  CENCOPAY = 'CENCOPAY',
  INVOICE = 'INVOICE'
}

export interface AccordionIndex {
  accordionIndex?: number | null;
  itemIndex?: number | null;
}
